import React, { Component } from "react";
import { connect } from "react-redux";
import { has } from "lodash";
import Skeleton from "react-loading-skeleton";
import Actions from "../../../../Actions";
import { Form as RForm, FormGroup, Label, Input, Button } from "reactstrap";
import * as Helpers from "../../../../Utilities/Common";

class Form extends Component{
    constructor(props){
        super(props);
        const { data: { name = "", location_id = "" } } = props; 
        this.state = { location_id, name };
    }

    setField = (endpoint, option, type = 0) => {
        Helpers.setField(endpoint, option, type, (dataObj) => this.setState(() => (dataObj)));
    }

    save = (event) => {
        event.preventDefault();
        const { persist, token, permissions, id = '' } = this.props;
        persist(token, this.state, permissions, id);
    }

    render = () => {
        const { location_id, name } = this.state;
        const { locationStore: { locations } } = this.props;
        return (
            has(locations, location_id) ? 
                <RForm>
                    <FormGroup>
                        <Label>
                            Location
                        </Label>
                        <Input disabled defaultValue={locations[location_id].name} />
                    </FormGroup>
                    <FormGroup>
                        <Label>
                            Name*
                        </Label>
                        <Input onChange={(value) => this.setField("name",value)} value={name} />
                    </FormGroup>
                    <FormGroup>
                            <Button block onClick={this.save} color="success" kind="squared">Save</Button>                           
                    </FormGroup>
                </RForm>: 
                
                <Skeleton count={15} />
            )
    }
}

const mapStateToProps = (state) => ({
    permissions: state.auth.permissions,
    token: state.auth.token,
    locationStore: state.locationStore,
});

export default connect(mapStateToProps, Actions.locations )(Form);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/SubLocations/Form.js